var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogolivetracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0428\\u0430\\u0440_1",
    "data-name": "\\u0428\\u0430\\u0440 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 211.98 209.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#145aa6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.34,45.14H79.66C60.05,45.14,44,61,44,80.42V219.59c0,19.4,16,35.27,35.65,35.27H220.34C240,254.86,256,239,256,219.59V80.42C256,61,240,45.14,220.34,45.14ZM106.89,213.36H82.48l21.61-126H128.5Zm49.68-.75h-24.3l14.93-87.5h24.3Zm48.7.75H182.06l8.49-52.8h23.2Z",
    transform: "translate(-44.01 -45.14)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogolivetracking);
export default __webpack_public_path__ + "static/media/Logolivetracking.e6405a423661306617cccc0f02a85c53.svg";
export { ForwardRef as ReactComponent };